export const getHypoglycemia = (store) => store.Hypoglycemia.data;
export const getSymptoms = (store) => store.Hypoglycemia.symptoms;
export const getHypoFlag = (store) => store.Hypoglycemia.hypoFlag;
